var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { ChevronDown } from 'react-feather';
import Seo from '../../components/Seo';
import Hero from '../../components/Hero';
import Paragraph from '../../components/Typography/Paragraph';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import axiosInstance from '../../config/axios';
import { api } from '../../config/api';
import { toast } from 'react-toastify';
import { useValidation, ValidationString } from '../../hooks/useValidation';
import TextArea from '../../components/Fields/TextArea';
import Button from '../../components/Button';
import { useWizard } from '../../hooks/useWizard';
import { useUser } from '../../hooks/useUser';
import { omitKeys } from '../../utils/Objects';
import { serialize } from 'object-to-formdata';
import Heading from '../../components/Typography/Heading';
import ModalBasic from '../../components/Modal/Basic';
import TextInput from '../../components/Fields/TextInput';
import { usePlaceholder } from '../../hooks/usePlaceholder';
var AccordionType;
(function (AccordionType) {
    AccordionType["SIGNUP"] = "SIGNUP";
    AccordionType["ACCOUNT"] = "ACCOUNT";
    AccordionType["OTHER"] = "OTHER";
})(AccordionType || (AccordionType = {}));
var classes = {
    accordion: {
        shadow: '0px 3px 17px rgba(0, 0, 0, 0.1)',
    },
    form: 'mt-8 flex flex-col gap-6',
};
var Help = function () {
    var _a = useValidation(), textRequired = _a.textRequired, emailRequired = _a.emailRequired;
    var getWizard = useWizard().getWizard;
    var getUserStorage = useUser().getUserStorage;
    var placeholders = usePlaceholder();
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState(false), modal = _c[0], setModal = _c[1];
    var _d = useState(false), expanded = _d[0], setExpanded = _d[1];
    var schema = yup.object().shape({
        email: emailRequired,
        description: textRequired,
    });
    var handleAccordion = function (panel) { return function (event, isExpanded) {
        setExpanded(isExpanded ? panel : false);
    }; };
    var _e = useForm({
        resolver: yupResolver(schema),
    }), handleSignUpSubmit = _e.handleSubmit, signUpControl = _e.control;
    var _f = useForm({
        resolver: yupResolver(schema),
    }), handleAccountSubmit = _f.handleSubmit, accountControl = _f.control;
    var _g = useForm({
        resolver: yupResolver(schema),
    }), handleOtherSubmit = _g.handleSubmit, otherControl = _g.control;
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var postData, formData, response, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoading(true);
                    postData = __assign(__assign(__assign({}, data), (getUserStorage() && { user: getUserStorage() })), (getWizard() && {
                        wizard: omitKeys((_a = getWizard()) === null || _a === void 0 ? void 0 : _a.values, ['password', 'password_confirmation']),
                    }));
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    formData = serialize(postData, { indices: true, allowEmptyArrays: true });
                    return [4 /*yield*/, axiosInstance.post(api.help.report, formData)];
                case 2:
                    response = _b.sent();
                    setModal(true);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _b.sent();
                    toast.error(ValidationString.GLOBAL);
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (<>
      <Seo title="Centre d'aide"/>
      <Hero title="Nous sommes là pour vous aider" headline="Centre d'aide"/>
      <div className="container">
        <div className="p-default mb-20 grid lg:grid-cols-12">
          <div className="lg:col-span-6 lg:col-start-4">
            <div className="flex flex-col gap-10">
              <Accordion expanded={expanded === AccordionType.SIGNUP} onChange={handleAccordion(AccordionType.SIGNUP)} sx={{
            boxShadow: classes.accordion.shadow,
            '&:before': {
                display: 'none',
            },
        }}>
                <AccordionSummary expandIcon={<ChevronDown />}>
                  <Paragraph className="w-1/3 flex-shrink-0">Inscription</Paragraph>
                  <Paragraph className="text-gray-400">Vous cherchez à vous inscrire ?</Paragraph>
                </AccordionSummary>
                <AccordionDetails>
                  <Paragraph>
                    Complétez ce formulaire pour obtenir l'aide de notre équipe. Nous reviendrons
                    vers vous au plus vite !
                  </Paragraph>
                  <form onSubmit={handleSignUpSubmit(onSubmit)} className={classes.form}>
                    <TextInput name="email" control={signUpControl} label="Email" required placeholder={placeholders.email}/>
                    <TextArea name="description" control={signUpControl} label="Votre message" placeholder={placeholders.helpDescription} required/>
                    <Button submit loading={loading}>
                      Envoyer
                    </Button>
                  </form>
                </AccordionDetails>
              </Accordion>
              <Accordion expanded={expanded === AccordionType.ACCOUNT} onChange={handleAccordion(AccordionType.ACCOUNT)} sx={{
            boxShadow: classes.accordion.shadow,
            '&:before': {
                display: 'none',
            },
        }}>
                <AccordionSummary expandIcon={<ChevronDown />}>
                  <Paragraph className="w-1/3 flex-shrink-0">Compte</Paragraph>
                  <Paragraph className="text-gray-400">
                    Besoin d'aide pour gérer votre compte ?
                  </Paragraph>
                </AccordionSummary>
                <AccordionDetails>
                  <Paragraph>
                    Complétez ce formulaire pour obtenir l'aide de notre équipe. Nous reviendrons
                    vers vous au plus vite !
                  </Paragraph>
                  <form onSubmit={handleAccountSubmit(onSubmit)} className={classes.form}>
                    <TextInput name="email" control={accountControl} label="Email" required placeholder={placeholders.email}/>
                    <TextArea name="description" control={accountControl} label="Votre message" placeholder={placeholders.helpDescription} required/>
                    <Button submit loading={loading}>
                      Envoyer
                    </Button>
                  </form>
                </AccordionDetails>
              </Accordion>
              <Accordion expanded={expanded === AccordionType.OTHER} onChange={handleAccordion(AccordionType.OTHER)} sx={{
            boxShadow: classes.accordion.shadow,
            '&:before': {
                display: 'none',
            },
        }}>
                <AccordionSummary expandIcon={<ChevronDown />}>
                  <Paragraph className="w-1/3 flex-shrink-0">Autre</Paragraph>
                  <Paragraph className="text-gray-400">Une question ? Une remarque ?</Paragraph>
                </AccordionSummary>
                <AccordionDetails>
                  <Paragraph>
                    Complétez ce formulaire pour obtenir l'aide de notre équipe. Nous reviendrons
                    vers vous au plus vite !
                  </Paragraph>
                  <form onSubmit={handleOtherSubmit(onSubmit)} className={classes.form}>
                    <TextInput name="email" control={otherControl} label="Email" required placeholder={placeholders.email}/>
                    <TextArea name="description" control={otherControl} label="Votre message" placeholder={placeholders.helpDescription} required/>
                    <Button submit loading={loading}>
                      Envoyer
                    </Button>
                  </form>
                </AccordionDetails>
              </Accordion>
            </div>
          </div>
        </div>
      </div>
      <ModalBasic handleClose={function () { return setModal(false); }} open={modal}>
        <div className="flex flex-col items-center gap-10">
          <Heading level={2} type="h5" className="text-center">
            Merci pour votre message !
          </Heading>
          <Paragraph className="text-center">
            Nous reviendrons vers vous au plus vite pour vous apporter une réponse. Alors, à bientôt
            🙂
          </Paragraph>
          <Button onClick={function () { return setModal(false); }}>C'est compris</Button>
        </div>
      </ModalBasic>
    </>);
};
export default Help;
